import { useState } from 'react';
import { Form, Button, Radio } from 'antd';
import { formatDUI, I18nt, numbersOnly } from 'utils';
import { InputText } from 'components/Inputs';
import InfoButton from 'components/InfoButton';
import validations from 'utils/validations/ConsultaMedicamentos';
import { AuthDocumentType, ConsultaMedicamentosFormParams } from 'utils/interfaces';
import { useConsultaMedicamentos } from '../ConsultaMedicamentosContext';
import BannerWithImage from 'components/BannerWithImage';
import styles from './ConsultaMedicamentos.module.less';



export default function FormView() {
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  const [authType, setAuthType] = useState<AuthDocumentType>('dui');
  const { isFormLoading, onFormSubmit } = useConsultaMedicamentos();

  const onValuesChange = (
    changedValues: ConsultaMedicamentosFormParams,
    allValues: ConsultaMedicamentosFormParams
  ) => {
    if (changedValues.afiliado) {
      allValues.afiliado = numbersOnly(changedValues.afiliado).slice(0, 10);
    }
    if (changedValues.receta) {
      allValues.receta = numbersOnly(changedValues.receta).slice(0, 10);
    }
    if (changedValues.dui) {
      allValues.dui = formatDUI(changedValues.dui).slice(0, 10);
    }
    if (changedValues.authType) {
      setAuthType(changedValues.authType);
      allValues.dui = '';
      allValues.afiliado = '';
    }
    form.setFieldsValue(allValues);

    const values = form.getFieldsValue();
    const duiValid = values.dui && values.dui.length === 10;
    const afiliadoValid = values.afiliado && values.afiliado.length > 0;
    const isAuthValid = duiValid || afiliadoValid;
    if (
      isAuthValid &&
      values.receta &&
      values.receta.length === 10
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const onFinish = (data: ConsultaMedicamentosFormParams) => {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { authType, ...requestData } = data;
    onFormSubmit(requestData, authType);
    form.resetFields(['dui', 'afiliado', 'receta']);
  };

  const getAuthField = () => {
    if (authType === 'dui') {
      return (<>
        <InputText
          name='dui'
          inputMode='numeric'
          label='dui'
          placeholder='placeholder_dui'
          rules={validations.dui}
        />
      </>);
    }

    return (<>
      <InfoButton image='carnet' />
      <InputText
        name='afiliado'
        inputMode='numeric'
        label='numero_de_afiliado'
        placeholder='placeholder_num_afiliado'
        rules={validations.afiliado}
      />
    </>);
  };

  return (
    <section className={styles.consultaMedicamentos}>
      <BannerWithImage className={styles.background}>
        <div className={styles.wrapper}>
          <div className={styles.formHeader}>
            <h4 className={styles.centerDesktop}>{I18nt('consulta_la_disponibilidad')}</h4>
            <p className={styles.centerDesktop}>{I18nt('solo_necesitas_dos')}</p>
          </div>
          <div className={styles.formContainer}>
            <Form
              form={form}
              layout='vertical'
              onFinish={onFinish}
              validateTrigger='onBlur'
              onValuesChange={onValuesChange}
              initialValues={{ authType: 'dui' }}
            >
              <Form.Item label={I18nt('documento_de_identificacion')} name="authType">
                <Radio.Group
                  size="large"
                  value={authType}
                  buttonStyle="solid"
                  optionType="button"
                  className={styles.identificationBox}
                >
                  <Radio.Button value="dui">{I18nt('dui')}</Radio.Button>
                  <Radio.Button value="afiliado">{I18nt('numero_afiliado')}</Radio.Button>
                </Radio.Group>
              </Form.Item>

              {getAuthField()}

              <InfoButton image='receta' />
              <InputText
                name='receta'
                inputMode='numeric'
                label='numero_de_receta'
                placeholder='placeholder_num_receta'
                rules={validations.receta}
              />
              <Form.Item className='mt-16'>
                <Button
                  loading={isFormLoading}
                  block
                  type='primary'
                  htmlType='submit'
                  disabled={disabled}
                >
                  {I18nt(isFormLoading ? 'buscando' : 'buscar_receta')}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </BannerWithImage>
    </section>
  );
}
